import { render, staticRenderFns } from "./LawNormFormByLawsItem.vue?vue&type=template&id=3d89af1e&scoped=true"
import script from "./LawNormFormByLawsItem.vue?vue&type=script&lang=js"
export * from "./LawNormFormByLawsItem.vue?vue&type=script&lang=js"
import style0 from "./LawNormFormByLawsItem.vue?vue&type=style&index=0&id=3d89af1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d89af1e",
  null
  
)

export default component.exports